import { useAdminUpdate } from '@reapitform/hooks'
import { AdminPdfField, AdminPdfFieldPayload } from '../types'

/** Creates a PDF field mapping under a form version (`POST …/versions/{versionRef}/pdf-fields`). */
export const useCreateAdminPdfField = (formReferenceID: string, versionReferenceID: string) =>
  useAdminUpdate<AdminPdfFieldPayload, AdminPdfField>({
    path: `/api/forms/${formReferenceID}/versions/${versionReferenceID}/pdf-fields`,
    method: 'POST',
    errorMessage: 'Failed to create the PDF field mapping',
    successMessage: 'PDF field mapping created',
  })
